import { hosts } from 'settings';

export const FormReview = {
  bindings: {
    wordingRating: '@',
    wordingSingular: '@',
    onSubmit: '&',
    onCancel: '&',
  },

  template: `
    <form class="form-review voome-form"
      name="form"
      ng-submit="$ctrl.onReview(form)"
      novalidate>
      <div class="form-group">
        <form-label for="review">
          Write your {{ $ctrl.wordingSingular | lowercase }}
        </form-label>
        <form-textarea
          name="review"
          form="form"
          rows="5"
          errors="{ required: 'This field is required' }"
          required="true">
        </form-textarea>
        <div class="mt-3 d-flex flex-row"
          ng-if="$ctrl.wordingRating">
          <input name="rating" type="hidden" value="form.data.rating">
          <span>{{ $ctrl.wordingRating }}:</span>
          <p class="ml-2">
            <rating-stars
              size="md"
              rating="form.data.rating"
              is-enabled="true"
              on-click="form.data.rating = value">
            </rating-stars>
          </p>
        </div>
      </div>
      <button class="btn btn-link pl-0"
        type="button"
        ng-click="$ctrl.onCancel(); $ctrl.reset(form)">
        Cancel
      </button>
      <button class="btn btn-pill theme-btn"
        type="submit"
        ng-disabled="form.$invalid">
        Post {{ $ctrl.wordingSingular }}
      </button>
    </form>`,

  controller($timeout) {
    'ngInject';

    return {
      onReview(form) {
        this.onSubmit({ data: form.data });
        this.reset(form);
      },

      onReviewCancel(form) {
        this.onCancel();
        this.reset(form);
      },

      reset(form) {
        form.data.review = undefined;
        form.data.rating = undefined;

        $timeout(() => {
          form.$setPristine();
          form.$setUntouched();
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormReview/FormReview.js